import { app } from "../../../../app";

class SharedFoldersResource {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    getSharedFolders(companyId) {
        const url = `app/rest/v2/company/${companyId}/sharedfolders`;
        return this.$http.get(url).then(({data}) => data);
    }

    createSharedFolder(companyId, name) {
        const url = `app/rest/v2/company/${companyId}/sharedfolders`;
        return this.$http.post(url, name).then(({data}) => data);
    }

    getAssignedUnassignedFoldersForCorporateItemId(corporateItemId, companyId, isNote) {
        let isNoteParam = isNote ? 'isNote=true' : 'isNote=false';
        const url = `app/rest/v2/company/${companyId}/sharedfolders/corporateitem/${corporateItemId}?${isNoteParam}`;
        return this.$http.get(url).then(({data}) => data);
    }

    addCorporateItemToSharedFolders(corporateItemId, folderIds, companyId, isNote) {
        let isNoteParam = isNote ? 'isNote=true' : 'isNote=false';
        const url = `app/rest/v2/company/${companyId}/sharedfolders/corporateitem/${corporateItemId}?${isNoteParam}`;
        return this.$http.post(url, folderIds).then(({data}) => data);
    }

    removeCorporateItemFromSharedFolders(corporateItemId, folderIds, companyId, isNote) {
        let isNoteParam = isNote ? 'isNote=true' : 'isNote=false';
        const url = `app/rest/v2/company/${companyId}/sharedfolders/corporateitem/${corporateItemId}?action=remove&${isNoteParam}`;
        return this.$http.post(url, folderIds).then(({data}) => data);
    }

    renameSharedFolder(companyId, sharedFolderId, newName) {
        const url = `app/rest/v2/company/${companyId}/sharedfolders/${sharedFolderId}/rename`;
        return this.$http.put(url, newName).then(({data}) => data);
    }

    deleteSharedFolder(companyId, sharedFolderId) {
        const url = `app/rest/v2/company/${companyId}/sharedfolders/${sharedFolderId}`;
        return this.$http.delete(url).then(({data}) => data);
    }

    getSharedFolderItems(companyId, sharedFolderId) {
        const url = `app/rest/v2/company/${companyId}/sharedfolders/${sharedFolderId}/items`;
        return this.$http.get(url).then(({data}) => data);
    }

    addCorporateServiceAccounts(companyId, sharedFolderId, csaIds) {
        const url = `app/rest/v2/company/${companyId}/sharedfolders/${sharedFolderId}/serviceAccounts`;
        return this.$http.post(url, csaIds).then(({data}) => data);
    }

    addCorporateNotes(companyId, sharedFolderId, noteIds) {
        const url = `app/rest/v2/company/${companyId}/sharedfolders/${sharedFolderId}/notes`;
        return this.$http.post(url, noteIds).then(({data}) => data);
    }

    removeItems(companyId, sharedFolderId, itemIds) {
        const url = `app/rest/v2/company/${companyId}/sharedfolders/${sharedFolderId}/items?action=remove`;
        return this.$http.post(url, itemIds).then(({data}) => data);
    }

    getSharedLabels(companyId, sharedFolderId) {
        const url = `app/rest/v2/company/${companyId}/sharedfolders/${sharedFolderId}/labels`;
        return this.$http.get(url).then(({data}) => data);
    }

    updateSharedLabels(companyId, sharedFolderId, labelDTOs) {
        const url = `app/rest/v2/company/${companyId}/sharedfolders/${sharedFolderId}/labels`;
        return this.$http.post(url, labelDTOs).then(({data}) => data);
    }

    getSharedUsers(companyId, sharedFolderId) {
        const url = `app/rest/v2/company/${companyId}/sharedfolders/${sharedFolderId}/users`;
        return this.$http.get(url).then(({data}) => data);
    }

    shareWithSaaspassId(companyId, sharedFolderId, saaspassId) {
        const url = `app/rest/v2/company/${companyId}/sharedfolders/${sharedFolderId}/users/share/${saaspassId}`;
        return this.$http.post(url).then(({data}) => data);
    }

    unshareWithSaaspassId(companyId, sharedFolderId, saaspassId) {
        const url = `app/rest/v2/company/${companyId}/sharedfolders/${sharedFolderId}/users/unshare/${saaspassId}`;
        return this.$http.post(url).then(({data}) => data);
    }
}

app.service('SharedFoldersResource', SharedFoldersResource);



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-folders/shared-folders-resource.service.js